import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import fetchData from 'Utilis/request';
import { useAppSelector } from '../store/hooks';
import { useSwipe } from 'store/useSwipe';
import Loader from 'components/Loader';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

interface StoryArticlesProps {
  post_title: string;
  source: string;
  reporter: string;
  images: any[];
}

const useHideHeader = () => {
  useEffect(() => {
    if (typeof document === 'undefined') return;
    const header = document.querySelector('header');    
    header?.classList.add('hide-header');
    return () => {
      header?.classList.remove('hide-header');     
    };
  }, []);
};

const GalleryDetails = () => {  
    const { onTouchStart, onTouchMove, onTouchEnd } = useSwipe();  
   const headerHeight = useAppSelector((state: any) => state.categoryNavigation.headerHeight || 0);
   const fooNavHeight = useAppSelector((state: any) => state.categoryNavigation.fooNavHeight || 0);
  const darkMode = useAppSelector((state:any) => state.categoryNavigation.darkmode); 
  const { photoSlug } = useParams<{ photoSlug: string }>();
  const navigate = useNavigate();
  const [storyData, setStoryData] = useState<StoryArticlesProps>();
  const [loading, setLoading] = useState(true);
  const [currentIndex, setCurrentIndex] = useState(0);
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {    
    const fetchStory = async () => {
      try {
        const response = await fetchData.getResult(`${API_BASE_URL}getGallaryDetail.php?slug=${photoSlug}`) || []; 
        if(response) setStoryData(response);                
      } catch (error) {
        console.error('Error fetching story:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchStory();
  }, [photoSlug]);

  useEffect(() => {
    const handleScroll = () => {
      if (!containerRef.current) return;
      
      // const container = containerRef.current;
      const scrollPosition = window.scrollY;
      const windowHeight = window.innerHeight;
      const currentSlide = Math.round(scrollPosition / windowHeight);
      
      setCurrentIndex(currentSlide);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleNextStory = (href: string) => {
    if (href) navigate(href);
  };

  if (loading) {
    return <div className="flex items-center justify-center h-screen"><Loader darkMode={darkMode}/></div>;
  }

  if (!storyData) {
    return <div className="flex items-center justify-center h-screen">Story not found</div>;
  }

  return ( 
      <div className={`gallery-container font-sans min-h-screen ${darkMode ? 'bg-gray-900 text-white' : 'bg-gray-100 text-gray-900'}`} ref={containerRef}>
      {/* Back Button */}
      {/* <button 
        className="fixed top-6 left-6 z-50 p-2 rounded-full shadow-lg backdrop-blur-sm"
        onClick={() => navigate(-1)}>
        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
        </svg>
      </button> */}
         <main
        className="px-3 gallery-details-container"
        style={{ height: `calc(100vh - ${fooNavHeight+10}px)`, overflowY: 'auto', paddingTop:headerHeight+10}}
        onTouchStart={onTouchStart}
        onTouchMove={onTouchMove}
        onTouchEnd={onTouchEnd}>

      {/* Story Pages */}
      {storyData.images.map((image, index) => (
        <section 
          key={index}
          className="h-screenx w-full relative flex flex-col justify-end"
          style={{
            scrollSnapAlign: 'start',            
          }}
        >
          <div className="absolutex inset-0 overflow-hidden">
            <img 
              src={image.image} 
              alt={image.meta_detail} 
              className="w-full h-full object-cover object-center"
            />
            {/* <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/30 to-transparent" /> */}
          </div>

          <div className="relative z-0">
            <div className={`max-w-3xl mx-auto backdrop-blur-sm p-6 rounded-xlx ${darkMode ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-200'} border-t z-10`}>
              <p className="text-xl md:text-2xl font-medium mb-4">{image.meta_detail}</p>
              
              {index === storyData.images.length - 1 && (
                <>
                  {image.href && (
                    <button
                      onClick={() => handleNextStory(image.href)}
                      className="mt-4 bg-red-600 hover:bg-red-700 px-6 py-2 rounded-lg font-medium transition-colors"
                    >
                      Continue to Next Story →
                    </button>
                  )}
                  <div className="mt-6 text-sm">
                    <p>Source: {storyData.source}</p>
                    <p>Reporter: {storyData.reporter}</p>
                  </div>
                </>
              )}
            </div>
          </div>

          {/* Scroll Indicator */}
          {index < storyData.images.length - 1 && (
            <div className="absolute bottom-0 left-1/2 transform -translate-x-1/2 z-0 animate-bounce">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-white/80" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 14l-7 7m0 0l-7-7m7 7V3" />
              </svg>
            </div>
          )}
        </section>
      ))}
      </main>
    </div>
  );
};

export default GalleryDetails;